import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// config
import { enUS } from '@mui/material/locale';

//
import enLocales from './en';
import srbLocales from './srb';

// ----------------------------------------------------------------------

const { VITE_APP_SUB_DIR } = import.meta.env;

const defaultLang = {
  label: 'English',
  value: 'en',
  systemValue: enUS,
  icon: `${VITE_APP_SUB_DIR}/assets/icons/flags/ic_flag_en.svg`,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      srb: { translations: srbLocales },
    },
    lng: defaultLang.value, // localStorage.getItem('i18nextLng') || defaultLang.value,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
